import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SwiperModule } from 'swiper/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { JustLightboxModule } from 'just-lightbox';
import { LightboxModule } from 'ngx-lightbox';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TagifyModule } from 'ngx-tagify';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import { ToastrModule, ToastNoAnimationModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PersonalizationService } from './shared/services/personalization.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { NgxLoaderSpinnerModule } from 'ngx-loader-spinner';

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // Ya no se inicializará desde aquí porque ya se hace de manera manual desde el servicio de Permisos
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideAuth(() => getAuth()),
    // provideFirestore(() => getFirestore()),
    // provideStorage(() => getStorage()),
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    Daterangepicker,
    NgCircleProgressModule.forRoot(),
    JustLightboxModule.forRoot(),
    LightboxModule,
    CKEditorModule,
    TagifyModule.forRoot(),
    SweetAlert2Module.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'es-ES'
    }),
    NgxDropzoneModule,
    NgWizardModule.forRoot(ngWizardConfig),
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgxLoaderSpinnerModule
  ],
  providers: [
    PersonalizationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
